

// window.addEventListener('load', function() {

// var btnfltr = document.querySelector('.template-collection .container .utility-bar .utility-bar__left a.utility-bar__item');
//   var cntctfltr = document.querySelector('.template-collection .container .filter-container');
//   var closfltr = document.querySelector('.template-collection .container .filter-container .filters .filters__heading .filters__close');
//   var ankrfltr = document.querySelector('.template-collection .container .filter-container .filter-shade');
  
//   // cntctfltr.classList.remove("filter-container--show-filters-desktop", "filter-container--show-filters-mobile");
  
//   btnfltr.addEventListener('click', function() {
//     alert("The paragraph was clicked.");
//     cntctfltr.classList.add("filter-container--show-filters-desktop", "filter-container--show-filters-mobile");
//       // cntctfltr.classList.toggle("filter-container--show-filters-desktop");
//       // cntctfltr.classList.toggle("filter-container--show-filters-mobile");
//   });

//   closfltr.addEventListener('click', function() {
//       cntctfltr.classList.remove("filter-container--show-filters-desktop", "filter-container--show-filters-mobile");
//   });

//   ankrfltr.addEventListener('click', function() {
//       cntctfltr.classList.remove("filter-container--show-filters-desktop", "filter-container--show-filters-mobile");
//   });





//   [closfltr, ankrfltr].forEach(element => {
//     element.addEventListener('click', () => {
//         cntctfltr.classList.remove("filter-container--show-filters-desktop", "filter-container--show-filters-mobile");
//     });
//   });

  
// });





document.addEventListener("DOMContentLoaded", function () {
    const currentUrl = window.location.href;

    // Menu item mapping (Existing menu items)
    const menuItems = {
        "https://coldest.com/collections/core-colors": ".cstm-hdr-mnu-sec .mnu-itm.core-collection",
        "https://coldest.com/collections/limitless-bottle-with-handle": ".cstm-hdr-mnu-sec .mnu-itm.drop-homcol",
        "https://coldest.com/collections/limitless-deals-and-steals": ".cstm-hdr-mnu-sec .mnu-itm.sale-collection",
        "https://coldest.com/pages/drop": ".cstm-hdr-mnu-sec .mnu-itm.drops-home",
        "https://coldest.com/pages/sale": ".cstm-hdr-mnu-sec .mnu-itm.sale-home"
    };

    // Extra pages where the menu should be visible
    const additionalPages = [
        "https://coldest.com/collections/for-her",
        "https://coldest.com/collections/for-him"
    ];

  // ,
  //       "https://coldest.com/pages/sale",
  //       "https://coldest.com/pages/drop",
  //       "https://coldest.com/collections/limitless-deals-and-steals",
  //       "https://coldest.com/collections/core-colors",
  //       "https://coldest.com/collections/limitless-bottle-with-handle"

    // Check and add active class for menu items
    Object.keys(menuItems).forEach(url => {
        if (currentUrl.includes(url)) {
            const menuItem = document.querySelector(menuItems[url]);
            if (menuItem) {
                menuItem.classList.add("mnu-actv");
            }
        }
    });

    // Check if the current page is in additionalPages
    // additionalPages.forEach(url => {
    //   const menu = document.querySelector(".cstm-hdr-mnu-sec");
    //     if (menu) {
    //         if (currentUrl.includes(url)) {
    //             menu.style.display = "block"; // Show menu if URL matches
    //         } else {
    //             menu.style.display = "none"; // Hide menu if URL does not match
    //         }
    //     }
    // });

    additionalPages.forEach(url => {
        if (currentUrl.includes(url)) {
            document.querySelector(".cstm-hdr-mnu-sec").style.display = "block"; // Ensure menu is visible
        }
    });

});









window.addEventListener("load", (event) => {

  
  // const imageUrls = [
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  //   'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903',
  // ];
  // const listItems = document.querySelectorAll('#NavigationTier2-6-mob .container > ul li.navigation__item');
  
  // listItems.forEach((li, index) => {
  //   const mnuimg = document.createElement('img');
  //   mnuimg.classList.add('cstm-mnu_img-cls');
  //   mnuimg.src = imageUrls[index] || 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Copy_of_Crowned_Luna_-_Post.png?v=1735412903';
  //   mnuimg.alt = `Menu Image ${index + 1}`;
  //   li.appendChild(mnuimg);
  // });



  
  

//    if (document.body.classList.contains("template-collection")) {


//      const productList = document.querySelector('.template-collection .filter-container .product-list');

//   const childDiv = document.createElement('div');
//   childDiv.classList.add('img-dv-cls'); 

//   const ankrElement = document.createElement('a');
//   ankrElement.href = 'https://coldest.com/collections/limitless-bottle-with-handle/products/coldest-limitless-bottle?variant=46924713361640';

//   const imgElement = document.createElement('img');
//   imgElement.src = 'https://cdn.shopify.com/s/files/1/0667/5650/9928/files/Moonlight_Hearts_-_Post_1.jpg?v=1737617711'; 
//   imgElement.alt = 'Product Image';

//   const hdngElement = document.createElement('h3');
//   hdngElement.innerText = "Coldest Valentine's Day Special";

//    const hdngElement1 = document.createElement('p');
//    hdngElement1.innerText = 'Moonlight Hearts';

// //   const ratingDiv = document.createElement('div');
// //   ratingDiv.className = 'product-block__rating';
// //   ratingDiv.style.marginTop = '3px';
// //   ratingDiv.innerHTML = `
// //     <div class="product-block__rating">
// //                   <div class="cc-rating" role="img" data-rating-decimal="0" aria-label="4.9 out of 5.0 stars">
// //     <span aria-hidden="true" class="cc-rating-stars">
// //       <span class="cc-rating-stars--inactive"><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg></span>
// //       <span class="cc-rating-stars--active"><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg><svg class="cc-rating-stars__svg" width="13" height="13" viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" style="width: 1.5em; height: 2em;">
// //   <path fill-rule="evenodd" clip-rule="evenodd" d="M8.43579 4.9459L13.63 4.9536L9.42653 8.01929L11.0329 12.97L6.81981 9.91778L2.60673 12.97L4.20346 8.01929L0 4.9536L5.20383 4.9459L6.81981 0L8.43579 4.9459Z"></path>
// // </svg></span>
// //     </span>
// //   </div>
// //   <p class="cc-rating-text">
// //     <span aria-hidden="true">4.9 / 5.0</span>
// //   </p>
  

// //                   <span class="cc-rating-custom-caption">
// //                     ( 771 )
// //                   </span>
// //                 </div>
// //   `;

//   childDiv.appendChild(ankrElement);
//   ankrElement.appendChild(imgElement);
//      ankrElement.appendChild(hdngElement1);
//   ankrElement.appendChild(hdngElement);
//   // ankrElement.appendChild(ratingDiv);

//   const firstChild = productList.children[1];
//   productList.insertBefore(childDiv, firstChild);

//    }

  
// Blackhawk Camo
  document.querySelector('.product-list .product-block[data-variant-id="46924712575208"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924712575208"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// Rocketship Alloy
  document.querySelector('.product-list .product-block[data-variant-id="46875870494952"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Low Inventory';
  document.querySelector('.product-list .product-block[data-variant-id="46875870494952"] .samita_productLabel-content[data-id="52332"]').id = 'LI';
// Blue Nova
  document.querySelector('.product-list .product-block[data-variant-id="46879904661736"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Low Inventory';
  document.querySelector('.product-list .product-block[data-variant-id="46879904661736"] .samita_productLabel-content[data-id="52332"]').id = 'LI';
// Crowned Luna
  document.querySelector('.product-list .product-block[data-variant-id="46875865940200"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46875865940200"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// Red Nova
  document.querySelector('.product-list .product-block[data-variant-id="46879904596200"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Low Inventory';
  document.querySelector('.product-list .product-block[data-variant-id="46879904596200"] .samita_productLabel-content[data-id="52332"]').id = 'LI';
// Moonlight Hearts
  document.querySelector('.product-list .product-block[data-variant-id="46924713361640"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713361640"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// The Republican
  document.querySelector('.product-list .product-block[data-variant-id="46924713623784"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713623784"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// The Democrat
  document.querySelector('.product-list .product-block[data-variant-id="46924713558248"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713558248"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// The Cardinal
  document.querySelector('.product-list .product-block[data-variant-id="46924713033960"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713033960"] .samita_productLabel-content[data-id="52332"]').id = 'JD';
// Avocado Reflections
  document.querySelector('.product-list .product-block[data-variant-id="46924713165032"] .samita_productLabel-content[data-id="52332"] span').innerText = 'Just Dropped';
  document.querySelector('.product-list .product-block[data-variant-id="46924713165032"] .samita_productLabel-content[data-id="52332"]').id = 'JD';




  

  // document.querySelector('.samita_productLabel-content').id = 'samita-badge-cstm-id';
 




  // const targetElement = document.querySelector('.cstm-prdct-cls .detail .swatches #swatch-option1 ul.swatch-view li.swatch-view-item[option-value-id="4011615617256"][aria-checked="true"]');

  // if (targetElement) {
  // const divToModify = document.querySelector('.cstm-prdct-cls .detail .gpo-app .gpo-element.gpo-form__group.show-addon-for-option');
  //  divToModify.classList.add('geo-hdn-cls');
  // } else {
  //   alert('The specified element does not exist or is not checked!');
  // }


  
  
  
  
});


document.addEventListener("DOMContentLoaded", function () {


  const lgnfrm = document.querySelector(".template-customers-login .small-form .opposing-items");                        
  const crtacc = document.createElement('span');
  crtacc.innerText = `Don't have an account?`;
  lgnfrm.appendChild(crtacc);



  
    setTimeout(() => {

const currentUrl = window.location.href;
    const targetUrl = "https://coldest.com/products/coldest-limitless-bottle?variant=46875866136808";

    if (currentUrl === targetUrl) {
        const productOption1 = document.querySelector(".gpo-container"); // Replace with the correct selector for your product option
        if (productOption1) {
            productOption1.classList.add("active");
        }
    }


      
        // Add click event listener to swatch items
        const swatchItems = document.querySelectorAll("#swatch-option1 .swatch-view-item");
        swatchItems.forEach(item => {
            item.addEventListener("click", function () {
                const productOption = document.querySelector(".gpo-container"); // Replace with the correct selector
                if (productOption) {
                    // Check if the clicked swatch has orig-value="Red Dress+"
                    if (this.getAttribute("orig-value") === "Red Dress+") {
                        productOption.classList.add("active");
                    } else {
                        productOption.classList.remove("active");
                    }
                }
            });
        });
    }, 5000); // Wait for 5 seconds to ensure elements are loaded
});






